// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimEscalationNoteResponseDto } from './IClaimEscalationNoteResponseDto';
import {
    IClaimEscalationNoteResponseDtoFromJSON,
    IClaimEscalationNoteResponseDtoFromJSONTyped,
    IClaimEscalationNoteResponseDtoToJSON,
    IClaimEscalationNoteResponseDtoToJSONTyped,
} from './IClaimEscalationNoteResponseDto';

/**
 * 
 * @export
 * @interface IClaimDto
 */
export interface IClaimDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimDto
     */
    age?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimDto
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimDto
     */
    category_type?: IClaimDtoCategoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimDto
     */
    claim_status?: IClaimDtoClaimStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IClaimDto
     */
    created_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IClaimDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimDto
     */
    payment_type?: IClaimDtoPaymentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IClaimDto
     */
    payment_method_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IClaimDto
     */
    updated_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IClaimDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimDto
     */
    receipt_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimDto
     */
    is_escalated?: boolean;
    /**
     * 
     * @type {IClaimEscalationNoteResponseDto}
     * @memberof IClaimDto
     */
    claim_escalation_note?: IClaimEscalationNoteResponseDto;
    /**
     * 
     * @type {number}
     * @memberof IClaimDto
     */
    contact_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimDto
     */
    service_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimDto
     */
    provider_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimDto
     */
    requested_amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IClaimDto
     */
    service_on?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimDto
     */
    is_appealed?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IClaimDto
     */
    appeal_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimDto
     */
    last_reminded_at?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IClaimDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
* @export
* @enum {string}
*/
export enum IClaimDtoClaimStatusEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimDtoPaymentTypeEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}


/**
 * Check if a given object implements the IClaimDto interface.
 */
export function instanceOfIClaimDto(value: object): value is IClaimDto {
    return true;
}

export function IClaimDtoFromJSON(json: any): IClaimDto {
    return IClaimDtoFromJSONTyped(json, false);
}

export function IClaimDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimDto {
    if (json == null) {
        return json;
    }
    return {
        
        'age': json['age'] == null ? undefined : json['age'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'claim_status': json['claim_status'] == null ? undefined : json['claim_status'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'payment_type': json['payment_type'] == null ? undefined : json['payment_type'],
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
        'updated_at': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'receipt_id': json['receipt_id'] == null ? undefined : json['receipt_id'],
        'is_escalated': json['is_escalated'] == null ? undefined : json['is_escalated'],
        'claim_escalation_note': json['claim_escalation_note'] == null ? undefined : IClaimEscalationNoteResponseDtoFromJSON(json['claim_escalation_note']),
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'service_id': json['service_id'] == null ? undefined : json['service_id'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
        'requested_amount': json['requested_amount'] == null ? undefined : json['requested_amount'],
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
        'is_appealed': json['is_appealed'] == null ? undefined : json['is_appealed'],
        'appeal_date': json['appeal_date'] == null ? undefined : (new Date(json['appeal_date'])),
        'last_reminded_at': json['last_reminded_at'] == null ? undefined : (new Date(json['last_reminded_at'])),
    };
}

export function IClaimDtoToJSON(json: any): IClaimDto {
    return IClaimDtoToJSONTyped(json, false);
}

export function IClaimDtoToJSONTyped(value?: IClaimDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'age': value['age'],
        'claim_id': value['claim_id'],
        'category_type': value['category_type'],
        'claim_status': value['claim_status'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'employee_id': value['employee_id'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'payment_type': value['payment_type'],
        'payment_method_id': value['payment_method_id'],
        'updated_at': value['updated_at'] == null ? undefined : ((value['updated_at']).toISOString()),
        'external_identifier': value['external_identifier'],
        'receipt_id': value['receipt_id'],
        'is_escalated': value['is_escalated'],
        'claim_escalation_note': IClaimEscalationNoteResponseDtoToJSON(value['claim_escalation_note']),
        'contact_id': value['contact_id'],
        'service_id': value['service_id'],
        'provider_name': value['provider_name'],
        'requested_amount': value['requested_amount'],
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString().substring(0,10)),
        'is_appealed': value['is_appealed'],
        'appeal_date': value['appeal_date'] == null ? undefined : ((value['appeal_date']).toISOString()),
        'last_reminded_at': value['last_reminded_at'] == null ? undefined : ((value['last_reminded_at']).toISOString()),
    };
}

